import React from "react";
import { node, oneOf, shape, string } from "prop-types";
import Hero from "@insightfulscience/atomic-react/Hero";

const HeroBrand = ({ brandCode = "sg", config, children, ...props }) => {
	const { color } = config;
	const brandColor = brand => color[brand];

	return (
		<Hero color={brandColor(brandCode)} {...props}>
			{children}
		</Hero>
	);
};

HeroBrand.propTypes = {
	brandCode: oneOf(["sg", "gp", "gn", "om", "la", "pm"]),
	config: shape({
		color: shape({
			gn: string,
			sg: string,
			gp: string,
			om: string,
			la: string,
			pm: string,
		}),
	}),
	children: node,
};

export default HeroBrand;
